import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import { Select, Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const { Option } = Select

const UserTypeSelect = ({ userTypes }) => {
  return (
    <>
      <span>{FIELD_LABEL.USER_TYPE_SELECT}</span>
      <Form.Item
        name={FIELD_NAME.USER_TYPE_UUIDS}
        rules={[RULES.REQUIRED]}
      >
        <Select
          bordered={false}
          mode='multiple'
          placeholder={'User Type'}
          showSearch={false}
          size='large'
          style={{ background: '#fff' }}
        >
          {userTypes.map(({ name, uuid }) => (
            <Option
              key={uuid}
              value={uuid}
            >
              {_.startCase(name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  )
}

UserTypeSelect.propTypes = {
  required: PropTypes.bool,
  userTypes: PropTypes.array
}

export default UserTypeSelect
